import React from 'react'

import { TopFilters as TopFiltersWrapper, ExcludedFilterSelect } from '@app/components'

import { FILTERS_PARAMS_KEYS } from '@app/api/constants'
import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { CONTRACTORS_KEY, LOCATION_KEY } from '@app/constants/queryKeys'

import { getStores } from '@app/api/routes/locationStores'
import { getClusters } from '@app/api/routes/locationСlusters'
import { getSalesOrganization } from '@app/api/routes/locationSalesOrganization'
import { getContractors } from '@app/api/routes/contractors'

import { useFiltersSearch } from '@app/hooks'
import { getFilterFromEntities } from '@app/utils/entitiesAdapters'

import { commonSelectProps } from './configs'

import type { FiltersParams } from '@app/types/filter'
import type { MonitoringTabTopFiltersProps } from './types'

export const TopFilters: React.FC<MonitoringTabTopFiltersProps> = ({ onSearch, initialFilters }) => {
  const { filters, canResetFilters, setFilters, handleClearFilters, handleSearch } = useFiltersSearch({
    initialFilters,
    onSearch
  })

  const handleExcludedSelectChange = (values: FiltersParams): void => {
    setFilters(prev => ({ ...prev, ...values }))
  }

  return (
    <TopFiltersWrapper
      canReset={ canResetFilters }
      onClear={ handleClearFilters }
      onSearch={ handleSearch }
    >
      <ExcludedFilterSelect
        { ...commonSelectProps }
        value={ filters.storeIds ?? filters.excludedStoreIds ?? [] }
        defaultIsExcluded={ !!filters.excludedStoreIds }
        paramKeys={ {
          key: FILTERS_PARAMS_KEYS.storeIds,
          excludedKey: FILTERS_PARAMS_KEYS.excludedStoreIds
        } }
        onChange={ handleExcludedSelectChange }
        placeholder={ FILTERS_PLACEHOLDERS.storesFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationStoresItems],
          queryFn: getStores,
          select: getFilterFromEntities
        } }
      />

      <ExcludedFilterSelect
        { ...commonSelectProps }
        value={ filters.clusterIds ?? filters.excludedClusterIds ?? [] }
        defaultIsExcluded={ !!filters.excludedClusterIds }
        paramKeys={ {
          key: FILTERS_PARAMS_KEYS.clusterIds,
          excludedKey: FILTERS_PARAMS_KEYS.excludedClusterIds
        } }
        onChange={ handleExcludedSelectChange }
        placeholder={ FILTERS_PLACEHOLDERS.clustersFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationClustersItems],
          queryFn: getClusters,
          select: getFilterFromEntities
        } }
      />

      <ExcludedFilterSelect
        { ...commonSelectProps }
        value={ filters.salesOrganizationIds ?? filters.excludedSalesOrganizationIds ?? [] }
        defaultIsExcluded={ !!filters.excludedSalesOrganizationIds }
        paramKeys={ {
          key: FILTERS_PARAMS_KEYS.salesOrganizationIds,
          excludedKey: FILTERS_PARAMS_KEYS.excludedSalesOrganizationIds
        } }
        onChange={ handleExcludedSelectChange }
        placeholder={ FILTERS_PLACEHOLDERS.salesOrganizationFilter }
        querySelect={ {
          queryKey: [LOCATION_KEY.locationSalesOrganizationsItems],
          queryFn: getSalesOrganization,
          select: getFilterFromEntities
        } }
      />

      <ExcludedFilterSelect
        { ...commonSelectProps }
        value={ filters.contractorIds ?? filters.excludedContractorIds ?? [] }
        defaultIsExcluded={ !!filters.excludedContractorIds }
        paramKeys={ {
          key: FILTERS_PARAMS_KEYS.contractorIds,
          excludedKey: FILTERS_PARAMS_KEYS.excludedContractorIds
        } }
        onChange={ handleExcludedSelectChange }
        placeholder={ FILTERS_PLACEHOLDERS.contractorsFilter }
        querySelect={ {
          queryKey: [CONTRACTORS_KEY.contractorsItems],
          queryFn: getContractors,
          select: getFilterFromEntities
        } }
      />
    </TopFiltersWrapper>
  )
}
